import BlogCard from "./blogCard";
import PageTitle from "../common/pageTitle";

const blogs = [
  {
    date: "Jan 19, 2025",
    imgUrl: "./assets/images/blogs/blog-10.png",
    title:
      "Enhancing Flutter HTTP Requests: Why Dio Outperforms the HTTP Package",
    link: "https://medium.com/@sharansukesh2000/enhancing-flutter-http-requests-why-dio-outperforms-the-http-package-3d64e414331b",
  },
  {
    date: "Dec 12, 2024",
    imgUrl: "./assets/images/blogs/blog-9.png",
    title: "Simplifying State Comparisons with Equatable in Flutter",
    link: "https://medium.com/@sharansukesh2000/simplifying-state-comparisons-with-equatable-in-flutter-b84526643585",
  },
  {
    date: "Oct 16, 2024",
    imgUrl: "./assets/images/blogs/blog-8.png",
    title: "Understanding AWS Accounts: A Beginner's Guide",
    link: "https://medium.com/@sharansukesh2000/understanding-aws-accounts-a-beginners-guide-e6713693a946",
  },
  {
    date: "Sep 02, 2024",
    imgUrl: "./assets/images/blogs/blog-7.png",
    title:
      "Step By Step Guide: Building a Multi-User Chat Application with Flutter and Firebase",
    link: "https://medium.com/@sharansukesh2000/step-by-step-guide-building-a-multi-user-chat-application-with-flutter-and-firebase-41751e46921a",
  },
  {
    date: "Aug 11, 2024",
    imgUrl: "./assets/images/blogs/blog-6.png",
    title: "Elevate Your Flutter App with the New CarouselView Widget",
    link: "https://medium.com/@sharansukesh2000/elevate-your-flutter-app-with-the-new-carouselview-widget-4f0872bdc9ed",
  },
  {
    date: "Jun 18, 2024",
    imgUrl: "./assets/images/blogs/blog-1.png",
    title: "A Beginner's Guide to Flutter Widget Testing",
    link: "https://medium.com/@sharansukesh2000/a-beginners-guide-to-flutter-widget-testing-f7e3cf5b61c4",
  },
  {
    date: "23rd May 2024",
    imgUrl: "./assets/images/blogs/blog-2.png",
    title: "How to block screenshot on Flutter Apps",
    link: "https://medium.com/@sharansukesh2000/protecting-your-flutter-app-implementing-screenshot-prevention-3c06d028e682",
  },
  {
    date: "Feb 5, 2024",
    imgUrl: "./assets/images/blogs/blog-3.png",
    title: "Understanding Flutter App Lifecycle: A Step-by-Step Guide",
    link: "https://medium.com/@sharansukesh2000/understanding-flutter-app-lifecycle-a-step-by-step-guide-89676251ac84",
  },
  {
    date: "Feb 2, 2024",
    imgUrl: "./assets/images/blogs/blog-4.png",
    title:
      "Implementing Text-to-Image Generation with Stability.ai : A Step-by-Step Guide",
    link: "https://medium.com/@sharansukesh2000/implementing-text-to-image-generation-with-stability-ai-api-a-step-by-step-guide-e63586339077",
  },
  {
    date: "Sep 16, 2023",
    imgUrl: "./assets/images/blogs/blog-5.png",
    title: "Implementing Flutter SearchDelegate: A Step-by-Step Guide",
    link: "https://medium.com/@sharansukesh2000/implementing-flutter-searchdelegate-a-step-by-step-guide-b8c4550627d1",
  },
];

function Blogs() {
  return (
    <div className="my-5 px-5">
      <PageTitle title={"Blogs"} />
      <div className="mt-10 md:grid md:grid-cols-2 gap-5">
        {blogs.map((blog, index) => (
          <BlogCard
            key={index}
            link={blog.link}
            date={blog.date}
            title={blog.title}
            delay={index * 0.1}
            imgUrl={blog.imgUrl}
          />
        ))}
      </div>
    </div>
  );
}

export default Blogs;
